<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="col-12">
    <div>
      <section-title
        class="mt-3"
        content="Firmas del Contratante"
        :has-line="true"
      />
      <row-message
        v-if="isElectronicSign && !showNoElectronicSignature()"
        class="row-message"
        :text="electronicMessageWarning"
        warning
      />
      <div class="pt-2">
        <div
          v-for="(row, index) of signatures"
          v-if="!row.isProvider && row.relationTypeId != null"
          :key="`signaturesprovider-item-${index}`"
          class="result-table pt-2"
        >
          <div class="row pt-2 col-12 pl-4 align-items-center">
            <div>
              <check-box
                :ref="`participant-${index}`"
                v-model="row.check"
                @input="onCheckParticipant($event, row, index)"
              />
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Nombre del Firmante:</div>
              <div class="color-black font-16 bold">
                {{ row.signatoryName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Parentesco:</div>
              <div class="color-black font-16 bold">
                {{ getRelationshipName(row.relationTypeId) }}
              </div>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }}
                {{ row.userName && '/ ' + row.userName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Número de Teléfono:</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>

            <div class="col-md-1 text-right">
              <div class="color-black font-16 bold">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-radio-button
                    :ref="`primarySigner-${index}`"
                    v-model="row.isPrimary"
                    custom-error-msg="Firmante es requerido."
                    :error="errors[0]"
                    :is-disabled="false"
                    is-inline
                    :name="`firmante`"
                    :options="
                      row.id > 0
                        ? [
                            {
                              label: '¿Contratante Principal?',
                              value: row.isPrimary ? true : index,
                            },
                          ]
                        : [
                            {
                              label: '¿Contratante Principal?',
                              value: index,
                            },
                          ]
                    "
                    @input="changePrimarySigner($event, row)"
                  />
                </validation-provider>
              </div>
            </div>
            <div
              v-if="canRefreshContractorInfo(row)"
              class="col-1 col-sm col-12 d-flex justify-content-end"
            >
              <action-button
                id="refresh-contractor-info"
                class="mr-3"
                i="fas fa-redo-alt"
                style="width: 43px;"
                variant="outline-success"
                @click="$emit('on-refresh-contractor-info', { ...row })"
              />
            </div>
            <div v-if="!isElectronicSign" class="col-md-1 pt-2 text-right">
              <action-button
                v-if="row.userId == null"
                class="btn-action-size-cancel"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger"
                @click="() => onDelete(row.id, index)"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="showNoElectronicSignature()">
        <div style="margin-bottom: -15px;">
          <row-message
            v-if="isElectronicSign"
            class="row-message"
            :text="noFoundElectronicMessage"
            warning
          />
        </div>
        <div class="result-table mt-2">
          <custom-result-not-found :text="'No hay información disponible.'" />
        </div>
      </div>
      <div
        v-if="isEdit() && !isElectronicSign"
        id="SignaturesContractorRef"
        class="pt-3"
      >
        <ValidationObserver
          ref="SignaturesContractorRef"
          v-slot="{}"
          tag="form"
        >
          <div class="result-table">
            <div class="row py-3 mr-md-0 col-12">
              <div class="row pt-2 col-12" style="padding-right: 0px;">
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">
                    Nombre del Firmante:
                  </div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="signatoryname"
                      v-slot="{ errors }"
                      name="signatoryname"
                      :rules="'required'"
                    >
                      <custom-input
                        v-model="model.signatoryname"
                        :custom-error-msg="
                          'El Nombre del Firmante es requerido.'
                        "
                        :error="errors[0]"
                        placeholder="Nombre del Firmante"
                        type="text"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Parentesco:</div>

                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="relationship"
                      v-slot="{ errors }"
                      name="relationship"
                      :rules="'required'"
                    >
                      <custom-drop-down
                        id="relationship"
                        v-model="model.relationtype"
                        :clearable="false"
                        :custom-error-msg="'El Parentesco es requerido.'"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        :options="relationtypeOptions"
                        placeholder="Seleccione"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Correo Electrónico:</div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      name="Email"
                      rules="required|email"
                    >
                      <custom-input
                        v-model="model.email"
                        :custom-error-msg="
                          failedRules['email']
                            ? 'El correo electrónico no es válido.'
                            : 'El correo electrónico es requerido.'
                        "
                        :error="errors[0]"
                        placeholder="Correo Electrónico"
                        type="email"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="color-gray-6 font-14">Número de Teléfono:</div>
                  <div class="color-black font-16 bold">
                    <validation-provider
                      ref="phone"
                      v-slot="{ errors }"
                      name="phone"
                      :rules="'required'"
                    >
                      <custom-input
                        v-model="model.phone"
                        :custom-error-msg="'El teléfono es requerido.'"
                        :error="errors[0]"
                        :mask-type="'Phone'"
                        placeholder="(___)___-____"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="row col-md-12 pt-4 button-table">
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger btn-cancel danger"
                  @click="() => onCancel()"
                />
                <action-button
                  class="btn-action-size ml-2"
                  i="fas fa-file-plus fa-lg mt-1 mb-1"
                  text="Añadir"
                  variant="success"
                  @click="() => saverequest()"
                />
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <div
      v-if="isShowButtonAdd() && !isElectronicSign"
      class="row col-md-12 pt-2 button-table"
    >
      <action-button
        class="btn-action-size ml-2"
        i="fas fa-file-plus fa-lg mt-1 mb-1"
        text="Añadir Participante"
        variant="success mt-2"
        @click="() => onShowEditForm()"
      />
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomRadioButton from 'custom-radio';
import CheckBox from 'CheckBox';
import RowMessage from '@/components/common/RowMessage.vue';
import CustomResultNotFound from 'custom-result-not-found';
import { getPeicode as _getPeicode } from '@/services/common/code.api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import roles from '@/utils/constants/roles.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { getcodeRelationshipNameByCode as _getRelationshipNameByCode } from '@/utils/constants/codeRelationship';
import { deleteSignatureHandwritten as _deleteSignatureHandwritten } from '@/services/uspqrp/signatures-contractor.api';

import { getParentsSignatures as _getParentsSignatures } from '@/services/uspqrp/provisional-remedy.api.js';
import { getUserInformation as _getUserInformation } from '@/services/uspqrp/contract.api.js';

// utils
import rpContractStatus from '@/utils/constants/rpContractStatus.js';

export default {
  name: 'SignaturesContractor',
  components: {
    SectionTitle,
    CustomInput,
    CustomDropDown,
    ActionButton,
    CheckBox,
    RowMessage,
    CustomResultNotFound,
    CustomRadioButton,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  async mounted() {
    if (this.contractId != null) {
      await this.getSignatures();
    }
    await this.getCodesByType();

    this.$root.$on('signatures-updated', () => {
      if (this.signaturesUpdated.length > 0) {
        this.signatures = this.signaturesUpdated;
      }
    });
  },
  data: () => ({
    model: {
      signatoryname: null,
      relationtype: null,
      email: null,
      phone: null,
      userid: null,
      isPrimary: null,
    },
    showEditForm: false,
    showButtonAdd: false,
    relationtypeOptions: [],
    signatures: [],
    pendingSignatures: [],
    relationTypeMap: {},
    noFoundElectronicMessage:
      'No se encontraron usuarios del portal de padres relacionados a este estudiante. Para poder firmar de manera electrónica el contratante debe tener acceso al portal. El contratante se puede registrar en la plataforma a través del siguiente enlace https://mipe-padres.dde.pr',
    electronicMessageWarning:
      'Si desean editar la información de los firmantes lo deberán realizar directamente en el portal de padres. Puede acceder a través del siguiente enlace https://mipe-padres.dde.pr',
  }),
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    contractInfo: {
      type: Object,
      default: () => {},
    },
    companyId: {
      type: Number,
      default: 0,
      required: false,
    },
    signaturesUpdated: {
      type: Array,
      default: () => [],
    },
    isElectronicSign: {
      type: Boolean,
      default: false,
    },
    primarySignerOptions: {
      type: Array,
      default: () => [
        {
          label: '¿Contratante Principal?',
          value: true,
        },
      ],
    },
    studentSieId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    canRefreshContractorInfo() {
      return (item) => {
        const contractStatusId = this.contractInfo?.contractStatusId;
        const isValidForElectronic =
          this.isElectronicSign &&
          !item.isProvider &&
          item.userId &&
          [
            rpContractStatus.New,
            rpContractStatus.Submitted,
            rpContractStatus.ApprovedContractInformation,
            rpContractStatus.DeniedContractInformation,
          ].includes(contractStatusId);

        const isValidForManuscrito =
          !this.isElectronicSign &&
          !item.isProvider &&
          item.userId &&
          [rpContractStatus.InSigningProcess].includes(contractStatusId);

        return isValidForElectronic || isValidForManuscrito;
      };
    },
  },
  methods: {
    async getCodesByType() {
      const payload = {
        codeType: 'Relationship',
        longName: false,
      };
      this.relationtypeOptions = (await _getPeicode(payload)).data;

      this.relationTypeMap = this.relationtypeOptions.reduce((map, option) => {
        map[option.id] = option.name;
        return map;
      }, {});
    },
    getRelationshipName(code) {
      return _getRelationshipNameByCode(code);
    },
    async getParentsSignatures() {
      this.signatures = [];
      this.signatures.length = 0;
      this.$emit('update-signatures', this.signatures);

      const parents = (
        await _getParentsSignatures(this.studentSieId, this.contractId)
      ).data;

      // Remove teacher from the list of parents
      const index = parents.findIndex(
        (signature) =>
          signature.roleId !== undefined &&
          signature.roleId !== null &&
          signature.roleId.toLowerCase() === roles.Teacher.toLowerCase()
      );

      if (index !== -1) {
        parents.splice(index, 1);
      }

      if (this.isElectronicSign) {
        this.signatures = parents.filter((x) => x.userId !== null);
      } else {
        this.signatures = parents;
      }

      const signaturesWithUserNames = await Promise.all(
        this.signatures.map(async (item) => {
          const rs = await _getUserInformation(item.userId);
          return {
            ...item,
            userName: rs.data.userName,
          };
        })
      );
      this.signatures = signaturesWithUserNames;

      this.$emit('update-signatures', this.signatures);
    },
    async getSignatures() {
      await this.getParentsSignatures();
    },
    async onDelete(id, index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) de que desea borrar este participante?`,
        'Sí',
        'No'
      );

      if (answer) {
        if (id) {
          await _deleteSignatureHandwritten(id);
          this.signatures = this.signatures.filter(
            (signature) => signature.id !== id
          );

          this.$emit('update-signatures', this.signatures);
        } else {
          this.signatures.splice(index, 1);

          if (this.pendingSignatures.length > 0) {
            this.pendingSignatures.splice(index - 1, 1);
            this.$emit('update-signatures', this.pendingSignatures);
          }

          this.$emit('update-signatures', this.signatures);
        }
        await this.getCodesByType();
        this.showEditForm = false;
        this.showButtonAdd = true;
        this.isShowButtonAdd();
        this.isEdit();
      } else {
        return;
      }
    },
    async saverequest() {
      const isValid = await this.$refs.SignaturesContractorRef.validate();
      if (isValid) {
        const newPendingSignature = {
          signatoryname: this.model.signatoryname,
          contractid: this.contractId,
          relationTypeId: this.model.relationtype?.id,
          email: this.model.email,
          phone: this.model.phone,
          userid: this.model?.userid,
          isProvider: false,
          isPrimary: false,
          check: true,
          roleid: null,
        };

        const newSignature = {
          signatoryName: this.model.signatoryname,
          relationType: this.model.relationtype?.name,
          relationTypeId: this.model.relationtype?.id,
          email: this.model.email,
          phone: this.model.phone,
          userid: this.model?.userid,
          isProvider: false,
          isPrimary: false,
          check: true,
        };

        const pendingSignatureExists = this.pendingSignatures.some(
          (s) =>
            s.signatoryname === newPendingSignature.signatoryname &&
            s.relationTypeId === newPendingSignature.relationTypeId &&
            s.email === newPendingSignature.email &&
            s.phone === newPendingSignature.phone &&
            s.userid === newPendingSignature.userid
        );

        if (!pendingSignatureExists) {
          this.pendingSignatures.push(newPendingSignature);
        }

        const signatureExists = this.signatures.some(
          (s) =>
            s.signatoryName === newSignature.signatoryName &&
            s.relationType === newSignature.relationType &&
            s.relationTypeId === newSignature.relationTypeId &&
            s.email === newSignature.email &&
            s.phone === newSignature.phone &&
            s.userid === newSignature.userid
        );

        if (!signatureExists) {
          this.signatures.push(newSignature);
        }

        this.$emit('update-signatures', this.pendingSignatures);
        await this.getCodesByType();
        this.clearModel();
        this.resetValidation();
        this.showEditForm = false;
      } else {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    onCancel() {
      this.showEditForm = false;
      this.showButtonAdd == true;
      this.isShowButtonAdd();
      this.isEdit();
      this.clearModel();
    },
    async clearModel() {
      this.model = {
        signatoryname: null,
        relationtype: null,
        email: null,
        phone: null,
      };
    },
    isShowButtonAdd() {
      var result = false;

      if (this.signatures.length < 3 && this.showEditForm == false) {
        result = true;
      }
      return result;
    },
    isEdit() {
      var result = false;
      if (this.signatures.length == 3) {
        result = false;
      } else if (
        this.showButtonAdd == false &&
        this.showEditForm == true &&
        this.signatures.length < 3
      ) {
        result = true;
      } else if (
        this.showButtonAdd == false &&
        this.showEditForm == true &&
        this.signatures.length == 0
      ) {
        result = false;
      }
      return result;
    },
    onShowEditForm() {
      this.showEditForm = true;
      this.showButtonAdd = false;
    },
    resetValidation() {
      this.$refs.SignaturesContractorRef.reset();
    },
    onCheckParticipant(checked, participant, index) {
      var checkboxRef = this.$refs[`participant-${index}`][0];

      if (checked) {
        if (this.signatures.filter((x) => x.check == true).length > 3) {
          this.ShowToast(
            'Error',
            'El sistema ha alcanzado el máximo de participantes (3) para la firma.',
            'error'
          );
          checkboxRef.model = false;
          return;
        } else {
          checkboxRef.model = true;
          this.$emit('update-signatures', this.signatures);
        }
      } else {
        checkboxRef.model = false;
        this.$emit('update-signatures', this.signatures);
      }
    },
    showNoElectronicSignature() {
      return (
        this.isElectronicSign &&
        (!this.signatures || this.signatures.length == 0)
      );
    },
    changePrimarySigner(event, row) {
      this.signatures = this.signatures.map((signature) => {
        return {
          ...signature,
          isPrimary: signature.id === row.id,
        };
      });
      this.$emit('update-signatures', this.signatures);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
  padding-bottom: 20px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
.button-table {
  justify-content: flex-end !important;
  float: right !important;
}
.mr-0 {
  padding-left: 16px !important;
}
.btn-action-size {
  width: auto !important;
}
.btn-action-size-cancel {
  width: 40px;
  height: 40px;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}

::v-deep input[type='checkbox'] + label span {
  background-color: white;
}
</style>
